// Superscript cents in dollar amounts helper plugin.
(function ($) {
	if(!$) { return; }

	$.fn.serializeHash = function (opts) {
	    var p = {}, opts = opts || {};
	    var a = this.serializeArray(opts);
	    $.each(a, function (i, n) {
	        p[n.name] = n.value;
	    });
	    return p;
	};

}(jQuery));
